import * as React from "react";
import H4 from "src/components/general/headings/H4";
import ParkSignTrace from "./ParkSignTrace";
import { ICouncil } from "src/interfaces";

interface IProps {
  councils: ICouncil[];
  year: string;
}

const ParkSign = (props: IProps) => (
  <div className="w-full lg:w-1/2 float-right">
    <div className="mb-8">
      <H4>Park area serviced per resident</H4>
    </div>
    <div className="flex flex-col">
      <div className="flex flex-row flex-wrap">
        {props.councils.map((council, index) => (
          <ParkSignTrace
            key={index}
            council={council}
            year={props.year}
            ordinal={index + 1}
          />
        ))}
      </div>
    </div>
  </div>
);

export default ParkSign;



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/Parks/ParkSign.tsx